import React from 'react';
import { Space, Tag } from 'antd';
import type { AdminUser } from './types';

const OAUTH_SOURCES: Record<string, { label: string; color?: string }> = {
  google: { label: 'Google', color: 'red' },
  facebook: { label: 'Facebook', color: 'blue' },
  local: { label: 'Local', color: 'default' },
  guest: { label: 'Guest', color: 'default' },
};

export function OAuthSourceBadges({ sources }: { sources: AdminUser['oauth_sources'] }) {
  return sources?.length ? (
    <Space size={[0, 4]} wrap>
      {sources.map((source) => (
        <Tag key={source} color={OAUTH_SOURCES[source]?.color}>
          {OAUTH_SOURCES[source]?.label ?? source}
        </Tag>
      ))}
    </Space>
  ) : <>—</>;
}
